// Mock impact/campaign data
export const mockImpactData = {
  campaigns: [
    {
      id: 'campaign_1',
      name: 'Summer Campaign 2024',
      status: 'active',
      reach: 125000,
      engagement: 8750,
      conversion_rate: 3.2,
      roi: 4.5,
      channels: ['email', 'social', 'paid_search']
    },
    {
      id: 'campaign_2',
      name: 'Spring SEO Push',
      status: 'completed',
      reach: 89000,
      engagement: 5670,
      conversion_rate: 2.8,
      roi: 3.8,
      channels: ['organic', 'seo']
    }
  ],
  total_conversions: 14500,
  total_revenue_attributed: 450000,
  attribution_model: 'multi-touch'
};
